import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategorySection />
      <HotSection />
      <LatestSection />
      <CTASection />
    </main>
  );
}